import styled from 'styled-components';
import { Spacer, mediaMinWidth, BackgroundColor, ColorMode, ComplementaryColor } from '@lux/core';
import { Title } from '@lux/title';
import { Button } from '@lux/buttons';

export const EACarouselContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${Spacer.M};

    ${mediaMinWidth.sm} {
        flex-direction: row;
    }
`;

export const DetailsWrapper = styled.div`
    padding: ${Spacer.M};
    background-color: ${({ theme }) => (theme.colorMode === ColorMode.DARK ? '#1a1a1a' : '#000')};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: ${Spacer.M};
    ${mediaMinWidth.sm} {
        gap: unset;
        max-width: 350px;
        padding: ${Spacer.M} ${Spacer.L};
    }
`;

export const TierPillWrapper = styled.div`
    display: flex;
    gap: ${Spacer.XS};
    align-items: center;
    margin-left: -2px;
`;

export const EarlyAccessLabel = styled.span`
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
`;

export const ContentWrapper = styled.div`
    display: contents;

    ${mediaMinWidth.sm} {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        justify-content: center;
        gap: ${Spacer.S};
    }
`;

export const StyledHeadline = styled(Title)`
    width: 100%;
    margin: 0;
    color: #ffffff;
`;

export const SeeAllButton = styled(Button)`
    width: fit-content;
    color: ${ComplementaryColor.neonFresh};

    &:after {
        background-color: ${ComplementaryColor.neonFresh};
    }

    &:focus,
    &:hover {
        color: #f3ffb1;

        &:after {
            background-color: #f3ffb1;
        }
    }

    &:active {
        color: #a1bf00;

        &:after {
            background-color: #a1bf00;
        }
    }
`;

export const EACarouselWrapper = styled.div`
    background-color: ${BackgroundColor.elevated};
    overflow-x: hidden;
    flex: 1;
    padding: ${Spacer.XS};
    padding-left: ${Spacer.M};

    ${mediaMinWidth.sm} {
        padding: ${Spacer.SM};
        padding-left: ${Spacer.S};
    }
`;

export const LastSeeAll = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
    min-width: 160px;
    overflow: hidden;
    cursor: pointer;
`;

export const LastSeeAllImage = styled.img`
    position: absolute;
    max-width: 100%;
    width: auto;
    height: auto;
`;

export const LastSeeAllOverlay = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
`;

export const LastSeeAllButton = styled.span`
    z-index: 2;
    position: relative;

    /* Force white color for the button text */
    span {
        color: #ffffff !important;

        &::after {
            background-color: #ffffff;
        }
    }
`;
